import i18n from '@/i18n'
i18n.mergeLocaleMessage('en', {
  "merchant.unpaid": "Unpaid",
  "Paid": "Paid",
  "PAYFAILED": "Payment Failed",
  "Paying": "Paying",
  "Unused": "Unused",
  "REFUNDING": "REFUNDING",
  "REFUNDED": "REFUNDED",
  "REFUNDEDREJECT": "REFUND REJECTED",
  "chat.Close": "Close",
  "Settlement": "Settlement",
  "OpenAccount": "Open Account",
  "AddMember": "Add Member",
  "RemoveMember": "Remove Member",
  "Transfer": "Transfer",
  "Payment": "Payment",
  "BankTransfer": "Bank Transfer",
  "RequestMoney": "Request Money",
  "CashOut": "Cash Out",
  "RedPacket.title": "Send Red Packet",
  "FxExchangeBuy": "FX Buy",
  "accountStr.fixed": "Fixed",
  "Repayment": "Repayment",
  "TrustyCoinsExchangeBuy": "Trusty Coins Exchange Buy",
  "JointAcctAplyBankTransferOutDirectDtl": "Direct Bank Transfer Out (Myanma Tourism Bank)",
  "GeneralMerchants": "General Merchants",
  "CashCounter": "Cash Counter",
  "agency_management": "Agency Payment Mgmt",
  "Restaurant": "Restaurant"
})
i18n.mergeLocaleMessage('zh', {
  "merchant.unpaid": "未支付",
  "Paid": "已支付",
  "PAYFAILED": "支付失败",
  "Paying": "支付中",
  "Unused": "未使用",
  "REFUNDING": "退款中",
  "REFUNDED": "已退款",
  "REFUNDEDREJECT": "拒绝退款",
  "chat.Close": "关闭",
  "Settlement": "结算",
  "OpenAccount": "开户",
  "AddMember": "添加成员",
  "RemoveMember": "移除成员",
  "Transfer": "转账",
  "Payment": "支付",
  "BankTransfer": "银行转账",
  "RequestMoney": "Request Money",
  "CashOut": "提现",
  "RedPacket.title": "发红包",
  "FxExchangeBuy": "外汇买入",
  "accountStr.fixed": "定期",
  "Repayment": "还款",
  "TrustyCoinsExchangeBuy": "Trusty币兑入",
  "JointAcctAplyBankTransferOutDirectDtl": "直接银行转账（缅甸旅游银行）",
  "GeneralMerchants": "一般商户",
  "CashCounter": "现金柜台",
  "agency_management": "工资代发",
  "Restaurant": "餐饮"
})
i18n.mergeLocaleMessage('mm', {
  "merchant.unpaid": "မရှင်းရသေး။",
  "Paid": "ပေးချေပြီး",
  "PAYFAILED": "ငွေပေးချေမှု မအောင်မြင်ပါ။",
  "Paying": "ပေးဆောင်ခြင်း",
  "Unused": "အသုံးမပြုရသေး",
  "REFUNDING": "ငွေပြန်အမ်းနေစဥ်",
  "REFUNDED": "ပြန်အမ်းငွေလက်ခံရရှိပြီး",
  "REFUNDEDREJECT": "ငွေပြန်အမ်းရန် မအောင်မြင်ပါ။",
  "chat.Close": "ပိတ်ရန်",
  "Settlement": "အခြေချနေထိုင်မှု",
  "OpenAccount": "ဖွင့်ထားသောအကောင့်",
  "AddMember": "အဖွဲ့ဝင်ထည့်မည်",
  "RemoveMember": "အဖွဲ့ဝင်ကို ဖယ်ရှားမည်",
  "Transfer": "ငွေလွှဲ",
  "Payment": "ပေးချေမှု",
  "BankTransfer": "ဘဏ်ငွေလွှဲ",
  "RequestMoney": "ပိုက်ဆံတောင်းတယ်။",
  "CashOut": "ငွေထုတ်",
  "RedPacket.title": "အနီရောင်ထုပ်ပို့ပါ",
  "FxExchangeBuy": "Fx Exchange ကိုဝယ်ပါ။",
  "accountStr.fixed": "ပြင်ပြီးပါပြီ",
  "Repayment": "ပြန်ပေးဆပ်ခြင်း",
  "TrustyCoinsExchangeBuy": "Trusty အကြွေစေ့လဲလှယ် ဝယ်ယူခြင်း",
  "JointAcctAplyBankTransferOutDirectDtl": "ဘဏ်မှ တိုက်ရိုက်ငွေလွှဲခြင်း (မြန်မာ့ခရီးသွားလုပ်ငန်းဘဏ်)",
  "GeneralMerchants": "အထွေထွေကုန်သည်များ",
  "CashCounter": "ငွေကောင်တာ",
  "agency_management": "အေဂျင်စီငွေပေးချေမှုစီမံခန့်ခွဲမှု",
  "Restaurant": "စားသောက်ဆိုင်"
})
  